import { render } from "./Preloader.vue?vue&type=template&id=3153878b"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=3153878b&lang=scss"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__